module.exports = __webpack_public_path__ + "static/media/aceshades-1.502a7145.png";